const dispatchChangeEventOnSelectComponent = () => {
  const productSelect = document.querySelector(".single-option-selector");

  const slideNextBtn = document.querySelector(
    ".flickity-prev-next-button.next"
  );
  const slidPrevBtn = document.querySelector(
    ".flickity-prev-next-button.previous"
  );

  //Dispatch event trigger to select each time that slideshow btn controls clicks
  var event = new Event("change");
  slideNextBtn.addEventListener("click", () => {
    productSelect.dispatchEvent(event);
  });
  slidPrevBtn.addEventListener("click", () => {
    productSelect.dispatchEvent(event);
  });
};
// Function to initialize the price update logic
function initializePriceUpdater() {
  const productSelect = document.querySelector(".single-option-selector");

  // Get the current price element
  const currentPriceElement = document.querySelector(
    ".product__price .current-price .money"
  );

  // Debugging: Check if the currentPriceElement exists
  if (!currentPriceElement) {
    console.error("Current price element not found");
    return;
  }

  // Create a function to update the price based on the selected variant
  function updatePrice() {
    // Find the script tag that contains the JSON-LD schema
    console.log("update price triggered");
    const scriptTag = document.querySelector("#productStructuredDataWS");

    if (scriptTag) {
      // Parse the JSON-LD content
      const productData = JSON.parse(scriptTag.textContent);

      // Function to get the price by variant ID
      function getPriceByVariantID(variantID) {
        // Ensure productData has offers
        if (productData.offers && Array.isArray(productData.offers)) {
          // Find the offer with the matching variant ID in the URL
          const offer = productData.offers.find((offer) =>
            offer.url.includes(variantID)
          );

          // If the offer is found, return the price
          if (offer) {
            return offer.price;
          } else {
            console.error(`Offer not found for variant ID: ${variantID}`);
            return null;
          }
        } else {
          console.error("No offers found in the JSON-LD schema.");
          return null;
        }
      }

      // Get the selected option value
      const selectedValue = productSelect.value;
      debugger;
      // Find the matching variant in the global product variants data
      //   const matchedVariant = theme.global.productVariants.find(
      //     (variant) => variant.option1 === selectedValue
      //   );

      //   if (matchedVariant) {
      //     const matchedVariantID = matchedVariant.id;
      //     const price = getPriceByVariantID(matchedVariantID);

      //     // Update the price element with the new price
      //     if (price) {
      //       currentPriceElement.innerText = `$${price}`;
      //     }
      //   }
    } else {
      console.error("JSON-LD script not found.");
    }
  }

  productSelect.addEventListener("change", updatePrice);
}

// Create a mutation observer to detect when .single-option-selector is added to the DOM
const domObserver = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === "childList") {
      const productSelect = document.querySelector(".single-option-selector");
      if (productSelect) {
        // Stop observing once the element is found and initialize
        domObserver.disconnect();
        initializePriceUpdater();
      }
    }
  }
});

// Start observing the document for changes to detect when .single-option-selector is added
domObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

setTimeout(() => {
  dispatchChangeEventOnSelectComponent();
}, 4000);
